import { Component } from 'preact'

import getWithInMemoryCache from '../../utils/getWithInMemoryCache'
import Navigation, { CategoryData } from '../knowledge-base/navigation'

interface Props {
  title: string
}

interface State {
  categories: CategoryData[]
  currentParent: null | number
}

export default class extends Component<Props, State> {
  private readonly categoryId: number = window.inSidedData.content.category.id

  constructor (props: Props) {
    super(props)
    this.state = {
      categories: [],
      currentParent: null
    }
  }

  async componentDidMount () {
    if (!this.categoryId) {
      return
    }
    const data = await getWithInMemoryCache('/site/community', {})
    const currentParent = data.categoryGroups.find((categoryGroup: CategoryData) => categoryGroup.id === this.categoryId)
    if (currentParent) {
      this.setState({ currentParent: this.categoryId })
    } else {
      for (const categoryGroup of data.categoryGroups) {
        const currentSubforum = categoryGroup.subforums.find((subforum: CategoryData) => subforum.id === this.categoryId)
        if (currentSubforum) {
          this.setState({ currentParent: categoryGroup.id })
          break
        }
      }
    }
    this.setState({ categories: data.categoryGroups })
  }

  render ({ title }: Props, { categories, currentParent }: State) {
    if (!this.categoryId) {
      return null
    }
    return (
      <div className='box__content box__pad widget-navigation'>
        {title ? <h3 className='widget-title'>{title}</h3> : ''}
        <Navigation
          currentCategory={this.categoryId}
          currentParent={currentParent || ''}
          categories={categories}
        />
      </div>
    )
  }
}
